import React, { useEffect, useState } from "react";
import CheckboxWrapper from "../../../components/scheduling/Checkbox.style";
import { Typography, Checkbox, Avatar, Popover } from "antd";
import { useIntl } from "react-intl";
import { useServiceTypes } from "../../../hooks";

const { Title, Text } = Typography;

const PatientListItem = (props) => {
  const {
    onFilterPatientsChanged,
    orderId,
    patientsPallette,
    events,
    order_time_extractions,
    filteredOrders,
  } = props;
  const intl = useIntl();
  const [name, setName] = useState(null);
  const [color, setColor] = useState("inherit");
  const [patient, setPatient] = useState({});
  const [clientName, setClientName] = useState("");
  const [hours, setHours] = useState(null);
  const [maxWeeklyHours, setMaxWeeklyHours] = useState(null);
  const [serviceType, setServiceType] = useState(null);
  const [serviceTypeName, setserviceTypeName] = useState(null);

  const [approved, setApproved] = useState(null);
  const isChecked = filteredOrders && !filteredOrders.includes(orderId);
  useEffect(() => {
    const filtered = events.filter((item) => item.order.id === orderId);
    if (filtered[0]) {
      setPatient(filtered[0].order.patient);
      const fullName =
        filtered[0].order.patient.surename +
        " " +
        filtered[0].order.patient.first_name;
      setName(fullName);
      setClientName(filtered[0].client_name);
      setMaxWeeklyHours(filtered[0].order.max_hours);
      setServiceType(filtered[0].order.service_type);
    }
    let total = 0;
    filtered.forEach((item, i) => {
      if (item.duration_minutes) {
        total = total + item.duration_minutes;
      }
    });

    const approvedEvents = filtered
      ? filtered.filter((i) => i.approved === true)
      : null;
    const approved_minutes = approvedEvents
      ? approvedEvents.reduce((a, b) => +a + +b.duration_minutes, 0)
      : 0;

    setHours(total);
    setApproved(approved_minutes);

    const patientColor = patientsPallette.filter(
      (item) => item.orderId === orderId
    )[0];
    if (patientColor) {
      setColor(patientColor.primary);
    }
  }, [orderId, events, patientsPallette]);

  const onChange = (e) => {
    onFilterPatientsChanged(orderId, e.target.checked);
  };

  const patientSrc = patient.avatar_url
    ? patient.avatar_url
    : patient.gender_id === 1
    ? require("../../../assets/eldery_man_avatar.png")
    : require("../../../assets/eldery_woman_avatar.png");

  const serviceTypes = useServiceTypes();

  useEffect(() => {
    const selected = serviceTypes
      ? serviceTypes.filter((item) => item.id === serviceType)[0]
      : null;
    if (selected) {
      setserviceTypeName(selected["name"]);
    }
  }, [serviceTypes, serviceType]);
  const content = (
    <div>
      {maxWeeklyHours && (
        <div style={{ display: "flex" }}>
          <p style={{ margin: 0, width: "95px" }}>{serviceTypeName}</p>
          <p style={{ margin: 0 }}>{maxWeeklyHours}</p>
        </div>
      )}
      <div style={{ display: "flex" }}>
        <p style={{ margin: 0, width: "95px" }}>
          {intl.formatMessage({
            id: "app.scheduling.required_minutes",
          })}
        </p>
        <p style={{ margin: 0 }}>
          {order_time_extractions[orderId] &&
            Math.round(
              (order_time_extractions[orderId].required_minutes / 60) * 100
            ) / 100}
        </p>
      </div>
      <div style={{ display: "flex" }}>
        <p style={{ margin: 0, width: "95px" }}>
          {intl.formatMessage({
            id: "app.scheduling.scheduled_minutes",
          })}
        </p>
        <p
          style={{
            margin: 0,
            color:
              order_time_extractions[orderId] &&
              order_time_extractions[orderId].scheduled_minutes >
                order_time_extractions[orderId].required_minutes
                ? "red"
                : "inherit",
          }}
        >
          {order_time_extractions[orderId] &&
            Math.round(
              (order_time_extractions[orderId].scheduled_minutes / 60) * 100
            ) / 100}
        </p>
      </div>
      <div style={{ display: "flex" }}>
        <p style={{ margin: 0, width: "95px" }}>
          {intl.formatMessage({
            id: "app.scheduling.approved_minutes",
          })}
        </p>
        <p style={{ margin: 0 }}>
          {order_time_extractions[orderId] &&
            order_time_extractions[orderId].approved_minutes &&
            Math.round(
              (order_time_extractions[orderId].approved_minutes / 60) * 100
            ) / 100}
        </p>
      </div>
    </div>
  );

  return (
    <div className="patientsContainer">
      <CheckboxWrapper checkboxColor={color}>
        <Checkbox
          checked={isChecked}
          onChange={onChange}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Popover
            content={content}
            className="content"
            placement="top"
            title={clientName}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar
                style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
                src={patientSrc}
              />
              <div style={{ padding: " 0 10px" }}>
                <Text
                  style={{
                    maxWidth: 120,
                  }}
                  ellipsis={{
                    tooltip: name,
                  }}
                >
                  {name}
                </Text>

                <Title level={4} style={{ margin: 0, padding: 0 }}>
                  {`${Math.round((approved / 60) * 100) / 100}/${
                    Math.round((hours / 60) * 100) / 100
                  }`}
                </Title>
              </div>
            </div>
          </Popover>
        </Checkbox>
      </CheckboxWrapper>
    </div>
  );
};

export default PatientListItem;
